import { Component, Input } from '@angular/core';
import { AccountGroup } from '@galaxy/account-group';
import { TranslateModule } from '@ngx-translate/core';
import { FormatAddressPipe } from './format-address.pipe';

@Component({
  selector: 'orders-company-address',
  styleUrls: ['../order-details.component.scss'],
  template: `
    <div class="column">
      <span class="column-title">
        {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.ADDRESS' | translate }}
      </span>
      @if (business?.napData; as napData) {
        <span class="column-content">
          <div>{{ napData | formatAddress }}</div>
        </span>
      }
    </div>
  `,
  imports: [TranslateModule, FormatAddressPipe],
})
export class CompanyAddressComponent {
  @Input() business: Pick<AccountGroup, 'napData'>;
}
